import { createConfigWall } from "../../helpers/wallData";
import { typeWallFoodit, typeWallLaNacion, typeWallClub } from "./typeWalls";

export const getWallData = (wallName) => {
    const configWall = getConfigWall(wallName);
    return createConfigWall(wallName, configWall);
};

const getConfigWall = (wallName) => {
    switch (wallName) {
        case "V_3":
        case "V_4":
        case "V_5":
        case "V_6":
            return typeWallFoodit;
        case "F_3":
            return typeWallClub;
        default:
            return typeWallLaNacion;
    }
};



// WEBPACK FOOTER //
// ./Statics/scripts/paywall/core/configWalls/getWallData.js